import React from "react";
import { MdHome, MdContactPage } from "react-icons/md";
import { IoMdPerson } from "react-icons/io";
import { CgFileDocument } from "react-icons/cg";
import { StateContext } from "../../../../Context/Context";
import { useContext } from "react";

export default function FixedLeftSideBar() {
  const { state } = useContext(StateContext);

  return (
    <div className="absolute px-[2%] lg:!px-[4%]">
      <div className="mt-[35vh] sm:mt-[30vh] flex flex-col gap-10 z-10">
        <button
          onClick={() => document.getElementById("home").scrollIntoView()}
        >
          <div
            className={`rounded-full flex justify-center items-center w-[32px] h-[32px] sm:w-[50px] sm:h-[50px] backdrop-blur-[1px] transition-all ${
              state.section === "home" ? "bg-primary-10/50" : "bg-secondary/50"
            }`}
          >
            <MdHome className="!text-base sm:!text-2xl" />
          </div>
        </button>
        <button
          onClick={() => document.getElementById("about").scrollIntoView()}
        >
          <div
            className={`rounded-full flex justify-center items-center w-[32px] h-[32px] sm:w-[50px] sm:h-[50px] backdrop-blur-[1px] transition-all ${
              state.section === "about" ? "bg-primary-10/50" : "bg-secondary/50"
            }`}
          >
            <IoMdPerson className="!text-base sm:!text-2xl" />
          </div>
        </button>
        <button
          onClick={() => document.getElementById("projects").scrollIntoView()}
        >
          <div
            className={`rounded-full flex justify-center items-center w-[32px] h-[32px] sm:w-[50px] sm:h-[50px] backdrop-blur-[1px] transition-all ${
              state.section === "projects"
                ? "bg-primary-10/50"
                : "bg-secondary/50"
            }`}
          >
            <CgFileDocument className="!text-base sm:!text-2xl" />
          </div>
        </button>
        <button
          onClick={() => document.getElementById("contact").scrollIntoView()}
        >
          <div
            className={`rounded-full flex justify-center items-center w-[32px] h-[32px] sm:w-[50px] sm:h-[50px] backdrop-blur-[1px] transition-all ${
              state.section === "contact"
                ? "bg-primary-10/50"
                : "bg-secondary/50"
            }`}
          >
            <MdContactPage className="!text-base sm:!text-2xl" />
          </div>
        </button>
      </div>
    </div>
  );
}
